import React, { useState } from "react";

export const InputSearchDNI = ({
  values,
  value,
  onChangeInput,
  onChangeSelect,
}: any) => {

  const LABELFILTRO: any = {
    documento: "Nº de documento",
    nombres: "Ingresa los datos",
  };

  const [type, setType] = useState<any>(LABELFILTRO["documento"]);

  let onChangeSelectReturn = (e: any) => {};

  const onChangeSelectIntercept = (event: any) => {
    const val = event.target.value;
    setType(LABELFILTRO[val]);
    return onChangeSelectReturn(event);
  };

  onChangeSelectReturn = onChangeSelect;
  return (
    <div className="inputSearch-form">
      <div className="workData__form__item input-field">
        <input
          type="text"
          autoComplete="off"
          maxLength={50}
          id="document"
          name="document"
          value={value}
          onChange={onChangeInput}
        />
        <label className={"activo"} htmlFor="document">
          {type}
        </label>
      </div>
    </div>
  );
};
